var map = {
	"./busd.svg": 1674,
	"./crypto-pending.png": 1675,
	"./crypto-reject.png": 1676,
	"./crypto-success.png": 1677,
	"./direpay.svg": 1678,
	"./trx.svg": 1679,
	"./usdc.svg": 1680,
	"./usdt.svg": 1681
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 263;